import _uniq from 'lodash/uniq'
import _get from 'lodash/get'

const Service = {
    stringVariableSwap(string, variables) {
        let newString = string;
        let matches = newString.match(/\{{(.*?)\}}/g);
        if (!matches) {
            return newString;
        }

        matches = _uniq(matches);
        matches.forEach((match) => {
            let key = match.replace('{{', '').replace('}}', '');
            let value = _get(variables, key, '');
            let regex = new RegExp(match, "g");
            newString = newString.replace(regex, value);
        });

        return newString;
    }
};

export default Service;
